import { RTEMatchInfo, RTEMatchInfoForResults } from '../types/rte';

function toSnakeCase(key: string): string {
	return key.replace(/([A-Z])/g, '_$1').toLowerCase();
}

function convertKeysToSnakeCase<T extends object>(input: T): Record<string, unknown> {
	const result: Record<string, unknown> = {};
	Object.keys(input).forEach((key) => {
		const snakeKey = toSnakeCase(key);
		result[snakeKey] = input[key as keyof T];
	});
	return result;
}

export function getMatchesInSnakeCase(matches: RTEMatchInfo[]): RTEMatchInfoForResults[] {
	return matches.map((match) => {
		const snakeCaseObj = convertKeysToSnakeCase(match);
		return snakeCaseObj as unknown as RTEMatchInfoForResults;
	});
}

export const shouldUseRTEHook = <T extends { matchStatus?: number; matchCompleted?: unknown }>(matches: T[], rteEnabled: boolean): boolean => {
	if (!rteEnabled) {
		return false;
	}

	return matches.some((match) => {
		return match.matchStatus !== 4 && !match.matchCompleted;
	});
};

export const shouldUseRTEHookResults = <T extends { match_status?: number; match_completed?: unknown }>(
	matches: T[],
	rteEnabled: boolean
): boolean => {
	if (!rteEnabled) {
		return false;
	}

	return matches.some((match) => {
		return match.match_status !== 4 && !match.match_completed;
	});
};
